import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormAutocomplete, Modal } from "../../common";
import { Button, Row } from "../../App.styles";
import { Textarea } from "../../common/Textarea";

const RejectModal = ({ onConfirm, onDismiss, show }) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const set = (setter) => {
    return (value) => {
        setter(value);
    }
  }

  return (
    <Modal onDismiss={onDismiss} show={show}>
      <div className="modal-header">
        <h4 className="modal-title">{t('Reject')}</h4>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-hidden="true"
          onClick={onDismiss}
        >
          ×
        </button>
      </div>
      <div className="modal-body">
        <Row>
          <FormAutocomplete 
            label={t("Points")}
            stateful={false}
            options={[{ id: 0, name: '0' }]}
            size="small"
          />
        </Row>
        <Row className="mt-2">
          <Textarea
            placeholder={t("Message to player")}
            rows={5}
            value={message}
            onChange={set(setMessage)}
            mode="clean"
          />
        </Row>
      </div>
      <div className="modal-footer">
        <Button color="dark" data-dismiss="modal" onClick={onDismiss}>
          {t('Cancel')}
        </Button>
        <Button color="primary" onClick={() => onConfirm(0, message)}>
          {t('Reject')}
        </Button>
      </div>
    </Modal>
  );
};

export default RejectModal;
